<mat-icon svgIcon="user" class="user-icon mr-5"></mat-icon>
{{ userCount }}
<mat-icon [svgIcon]="expanded ? 'chevron-down' : 'chevron-right'" class="small-chevron"></mat-icon>
